var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5248 3.17899L14.4582 0.1123C14.3861 0.041192 14.2884 0.00207111 14.1872 0.00337513V0H1.15382C0.942026 0 0.770508 0.171518 0.770508 0.383308V22.6167C0.770508 22.8285 0.942026 23 1.15382 23H17.2538C17.4656 23 17.6372 22.8285 17.6372 22.6167V3.45H17.6338C17.6345 3.3489 17.5954 3.2514 17.5248 3.17899ZM14.5705 1.30871L16.3285 3.06669H14.5705V1.30871ZM1.5372 22.2333V0.766692H13.8038V3.45C13.8038 3.66179 13.9754 3.83331 14.1872 3.83331H16.8705V22.2333H1.5372Z",
    fill: "#74A3C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8538 5.3667H21.0871V4.98331C21.0871 4.34833 20.5721 3.83331 19.9371 3.83331C19.3021 3.83331 18.7871 4.34833 18.7871 4.98331V20.3167C18.7865 20.376 18.7996 20.4347 18.8254 20.488L19.5921 22.0214C19.6569 22.1517 19.7897 22.2336 19.9353 22.2336C20.0807 22.2336 20.2133 22.1517 20.2784 22.0214L21.045 20.488C21.0722 20.4351 21.0865 20.3765 21.0871 20.3167V6.13331H21.4705V10.35H22.2371V5.75001C22.2371 5.53822 22.0656 5.3667 21.8538 5.3667ZM19.5537 4.98331C19.5537 4.77152 19.7253 4.60001 19.9371 4.60001C20.1489 4.60001 20.3204 4.77152 20.3204 4.98331V5.3667H19.5537V4.98331ZM20.3204 20.2262L19.9371 20.9929L19.5537 20.2262V6.13331H20.3204V20.2262Z",
    fill: "#74A3C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.30371 4.60004H16.1037V5.36673H2.30371V4.60004Z",
    fill: "#74A3C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.30371 13.8H16.1037V14.5667H2.30371V13.8Z",
    fill: "#74A3C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.30371 6.89996H13.8037V7.66665H2.30371V6.89996Z",
    fill: "#74A3C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.30371 9.20001H13.8037V9.9667H2.30371V9.20001Z",
    fill: "#74A3C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.30371 11.5H13.8037V12.2667H2.30371V11.5Z",
    fill: "#74A3C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5039 20.3167H16.1039V21.0833H11.5039V20.3167Z",
    fill: "#74A3C7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContract);
export default __webpack_public_path__ + "static/media/contract.a761f05d84343c927ff9cedff45207c4.svg";
export { ForwardRef as ReactComponent };